import React, { Component } from 'react';
import PureCounter from "@srexi/purecounterjs";
import TestimonialsComponent from './TestimonialsComponent';
import { TickIcon } from '../../../resources/svg';

class AboutComponent extends Component {

    componentDidMount() {
        // Initialize PureCounter.js when the component mounts
        new PureCounter(
            {
                formater: "us-US",
                separator: true, 
            }
        );
    }

    render() {
        return (
            <>
                {/* Whoe are we */}
                <section id="about" className="about section">

                    <div className="container section-title" data-aos="fade-up">
                        <h2>About Us<br /></h2>
                        <p>Top Talent, Competitive Pricing, and Exceptional IT Services with 5+ Years of experience</p>
                    </div>

                    <div className="container">

                        <div className="row gy-4">

                            <div className="col-lg-12 justified content" data-aos="fade-up" data-aos-delay="100">
                                <p>
                                    At TRB, we specialize in delivering exceptional solutions that empower businesses to thrive in the digital era. By harnessing cutting-edge technologies, we drive digital transformation for tech startups, mid-sized companies, and enterprises. Our comprehensive services—spanning Digital Consultancy, Data Science & Analytics, Software Development, and UI/UX Design—are designed to fuel innovation and accelerate growth.
                                </p>
                                <p>Through our Resource Augmentation offerings, we provide seamless access to top-tier talent, enabling clients to scale their projects efficiently and achieve their goals with confidence. Our team of seasoned professionals brings extensive industry expertise, ensuring tailored solutions that address unique business challenges.</p>
                                <ul>
                                    {/*
                                        <li><i className="bi bi-check2-circle"></i> <span>Best Trusted Partner</span></li>
                                        <li><i className="bi bi-check2-circle"></i> <span>24/7 Technical Support</span></li>
                                    */}
                                    <li><i><TickIcon /></i> <span>Cutting-edge technologies to stay ahead of curve</span></li>
                                    <li><i><TickIcon /></i> <span>Work closely with clients to deliver desired solutions</span></li>
                                    <li><i><TickIcon /></i> <span>Empower our clients to scale and succeed</span></li>
                                </ul>
                            </div>

                            {/* <div className="col-lg-6" data-aos="fade-up" data-aos-delay="200">
                                <p>Through our Resource Augmentation offerings, we provide seamless access to top-tier talent, enabling clients to scale their projects efficiently and achieve their goals with confidence. Our team of seasoned professionals brings extensive industry expertise, ensuring tailored solutions that address unique business challenges.</p>
                                <a href="#" className="read-more"><span>Read More</span><i className="bi bi-arrow-right"></i></a>
                            </div> */}

                        </div>

                    </div>

                </section>

                {/* Stats */}
                <section id="stats" className="stats section light-background">

                    <div className="container" data-aos="fade-up" data-aos-delay="100">

                        <div className="row gy-4">

                            <div className="col-lg-3 col-md-6">
                                <div className="stats-item text-center w-100 h-100">
                                    <span data-purecounter-start="0" data-purecounter-end="10" data-purecounter-duration="1" className="purecounter"></span>
                                    <p>Clients</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6">
                                <div className="stats-item text-center w-100 h-100">
                                    <span data-purecounter-start="0" data-purecounter-end="50" data-purecounter-duration="1" className="purecounter"></span>
                                    <p>Projects</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6">
                                <div className="stats-item text-center w-100 h-100">
                                    <span data-purecounter-start="0" data-purecounter-end="10400" data-purecounter-duration="1" className="purecounter"></span>
                                    <p>Hours Of Support</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6">
                                <div className="stats-item text-center w-100 h-100">
                                    <span data-purecounter-start="0" data-purecounter-end="20" data-purecounter-duration="1" className="purecounter"></span>
                                    <p>Workers</p>
                                </div>
                            </div>

                        </div>

                    </div>

                </section>

                {/* What we do */}
                <section id="about-alt" className="about-alt section">

                    <div className="container">

                        <div className="row gy-4">
                            <div className="col-lg-6 position-relative align-self-start" data-aos="fade-up" data-aos-delay="100">
                                <img src="assets/img/satisfaction.jpg" className="img-fluid" alt="" />
                                {/* <a href="https://www.youtube.com/watch?v=9Y7ma241N8k" className="glightbox pulsating-play-btn"></a> */}
                            </div>
                            <div className="col-lg-6 content justified" data-aos="fade-up" data-aos-delay="200">
                                {/* <h4 className='themeHotColor'>Guaranteed Customer Satisfaction</h4> */}
                                <h3>Your Satisfaction, Our Priority</h3>
                                <p>
                                    We are dedicated to providing exceptional IT services that are precisely tailored to meet your unique needs. By adopting an agile approach, we ensure seamless communication, flexibility, and the timely delivery of every project.
                                </p>
                                <p>
                                    As your Best Trusted Partner, we go beyond delivering services—we build relationships founded on trust, transparency, and mutual success. With our unwavering commitment to quality and excellence, you can rely on us to help navigate challenges and achieve your goals with confidence.
                                </p>
                                <p>
                                    We place a strong emphasis on continuous improvement, ensuring our solutions evolve with your business. Scalability is at the core of our services, enabling you to adapt to changing demands without compromising efficiency. Beyond project completion, we provide ongoing support to fine-tune and optimize your systems, ensuring they remain reliable and effective.
                                </p>
                                <p>
                                    Our 24/7 Technical Support team ensures that help is always just a call or click away. From troubleshooting critical issues to addressing everyday queries, we’re here around the clock to keep your operations running smoothly.
                                </p>
                                <p>
                                    With our client-first approach, we aim to build lasting relationships rooted in trust and transparency. Our team is dedicated to empowering your business with cutting-edge technology and round-the-clock support. Together, we’ll achieve your goals and set new standards for excellence.
                                </p>
                                <ul>
                                    <li><i><TickIcon /></i> <span>Best Trusted Partner</span></li>
                                    <li><i><TickIcon /></i> <span>24/7 Technical Support</span></li>
                                    {/* <li><i className="bi bi-check2-all"></i> <span>Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate trideta storacalaperda mastiro dolore eu fugiat nulla pariatur.</span></li> */}
                                </ul>
                                {/* <p>
              Ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate
              velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident
            </p> */}
                            </div>
                        </div>

                    </div>

                </section>

                <TestimonialsComponent />
            </>
        )
    }
}

export { AboutComponent };
